/**
 * Avalara © 2018
 * file: engines/opus_ui/src/search/ContactLink.js
 */

import React from 'react';

const salesforceBaseURL = 'https://avalara.my.salesforce.com/';

const getLink = (data) => `${salesforceBaseURL}${data.id}`;

const ContactLink = ({ data, type }) => {
  return (
    <div className="Summary">
      <div className="SummaryTitle">
        <a href={getLink(data)}>
          <div className="Type">Contact</div>
          <div className="Value">{`${data.name}`}</div>
        </a>
      </div>
      <div className="SummaryLink">
        <a href={getLink(data)}>{getLink(data)}</a>
      </div>
      <div className="SummaryData">
        <p>Email : {data.email}</p>
        <p>Online Authorized : {data.onlineAuthorized ? 'True' : 'False'}</p>
        <p>
          Customer:{' '}
          {data.customer && data.customer.name
            ? data.customer.name
            : 'No customer associated with this contact'}
        </p>
      </div>
    </div>
  );
};

export default ContactLink;
